/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash dc8730e794866555c056783b8aa64ef2 */

import { ConcreteRequest } from "relay-runtime";

export type userGeoInfoQueryVariables = {
    userId?: string | null | undefined;
    cookieDomain?: string | null | undefined;
};
export type userGeoInfoQueryResponse = {
    readonly viewer: {
        readonly regionalInfo: ReadonlyArray<{
            readonly countryCode: string | null;
            readonly zipCode: string | null;
            readonly regionsByZipCode: ReadonlyArray<{
                readonly displayName: string | null;
                readonly urlLabel: string | null;
            } | null> | null;
            readonly incomeLevel: {
                readonly incomeBracket: string | null;
                readonly incomePercentile: string | null;
            } | null;
        } | null> | null;
    };
};
export type userGeoInfoQuery = {
    readonly response: userGeoInfoQueryResponse;
    readonly variables: userGeoInfoQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "cookieDomain"
    } as any, v1 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "userId"
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "cookieDomain",
            "variableName": "cookieDomain"
        } as any,
        {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryCode",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zipCode",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "concreteType": "RegionsByZipCode",
        "kind": "LinkedField",
        "name": "regionsByZipCode",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlLabel",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "concreteType": "IncomeLevel",
        "kind": "LinkedField",
        "name": "incomeLevel",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incomeBracket",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incomePercentile",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "userGeoInfoQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": (v2 /*: any*/),
                            "concreteType": "RegionalInfo",
                            "kind": "LinkedField",
                            "name": "regionalInfo",
                            "plural": true,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "userGeoInfoQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": (v2 /*: any*/),
                            "concreteType": "RegionalInfo",
                            "kind": "LinkedField",
                            "name": "regionalInfo",
                            "plural": true,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v7 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/userGeoInfoQuery",
            "metadata": {},
            "name": "userGeoInfoQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '3226ea68342751da356bdbfd98f225c0';
export default node;
